export default __webpack_public_path__ + "static/media/Jacques_Blanchard_-_Hl._Hieronymus.b1c28deb.jpg";